import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BranchContext = createContext(null);
const STORAGE_KEY = "cashcollect.branch_id";

// Same origin base
const envUrl = process.env.REACT_APP_BACKEND_URL || "";
const origin = typeof window !== "undefined" ? window.location.origin : "";
const BACKEND_URL = origin || envUrl;
const API = `${BACKEND_URL}/api`;

export function BranchProvider({ children }) {
  const [branches, setBranches] = useState([]);
  const [branchId, setBranchIdState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "";
    } catch {
      return "";
    }
  });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/branches`);
      const list = res.data || [];
      setBranches(list);
      // If no branch is selected yet, pick the default (Punalur) or first
      if (!branchId || !list.find((b) => b.id === branchId)) {
        const preferred = list.find((b) => b.name === "Punalur") || list[0];
        if (preferred) {
          setBranchIdState(preferred.id);
          try {
            localStorage.setItem(STORAGE_KEY, preferred.id);
          } catch {}
        }
      }
    } finally {
      setLoading(false);
    }
  }, [branchId]);

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setBranchId = useCallback((id) => {
    setBranchIdState(id);
    try {
      localStorage.setItem(STORAGE_KEY, id);
    } catch {}
  }, []);

  const activeBranch = branches.find((b) => b.id === branchId) || null;

  return (
    <BranchContext.Provider
      value={{
        branches,
        branchId,
        setBranchId,
        activeBranch,
        loading,
        refreshBranches: load,
      }}
    >
      {children}
    </BranchContext.Provider>
  );
}

export function useBranch() {
  const ctx = useContext(BranchContext);
  if (!ctx) throw new Error("useBranch must be used within BranchProvider");
  return ctx;
}

// Helper to get the current branch id outside React (for axios interceptor / URL builders)
export function getCurrentBranchId() {
  try {
    return localStorage.getItem(STORAGE_KEY) || "";
  } catch {
    return "";
  }
}
